import axios from 'axios';
import { getVenueTypes } from '../constants/endpoints';

const normalizeVenueType = (item) => {
    if (!item) return null;
    const id = item.id ?? item.value ?? item.code ?? item.name;
    if (id == null) return null;
    return {
        id,
        name: item.name ?? item.description ?? String(id),
        description: item.description ?? '',
        category: item.category ?? item.category_id ?? null,
        parentCategory: item.parent_category ?? item.parentCategory ?? null,
        parentCategoryName:
            item.parent_category_name ?? item.parentCategoryName ?? null,
        raw: item,
    };
};

export const getVenueTypesList = async () => {
    const { data } = await axios.get(getVenueTypes);
    const rawList = Array.isArray(data?.result)
        ? data.result
        : Array.isArray(data?.results)
        ? data.results
        : Array.isArray(data?.data)
        ? data.data
        : [];

    return rawList
        .map((item) => normalizeVenueType(item))
        .filter(Boolean)
        .sort((a, b) => a.name.localeCompare(b.name));
};
